import { render } from "./IndividualTool.vue?vue&type=template&id=98be144c&scoped=true"
import script from "./IndividualTool.vue?vue&type=script&lang=js"
export * from "./IndividualTool.vue?vue&type=script&lang=js"

import "./IndividualTool.vue?vue&type=style&index=0&id=98be144c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98be144c"]])

export default __exports__